var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lwf-badge',_vm._b({attrs:{"label":_vm.labels[_vm.value ? 1 : 0],"color":_vm.colors[_vm.value ? 1 : 0]}},'lwf-badge',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }